import { render, staticRenderFns } from "./FormPolizaDialog.vue?vue&type=template&id=9514a23c"
import script from "./FormPolizaDialog.vue?vue&type=script&lang=js"
export * from "./FormPolizaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports